import { type UseQueryResult, useQuery } from 'react-query';
import {
  TransferAllocateService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetTransferAllocateDetailByTransactionId = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId?: string,
  transactionId?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto | undefined,
  unknown
> => {
  return useQuery(
    ['getTransferAllocateDetailByTransactionId', companyId, transactionId],
    async () => {
      if (companyId && transactionId) {
        return await handleRequest(
          TransferAllocateService.getApiAwardBrokerTradeToolTransferAllocateDetailByTransactionId(
            companyId,
            transactionId
          )
        );
      }
    },
    {
      enabled: !!companyId && !!transactionId,
    }
  );
};

export default useGetTransferAllocateDetailByTransactionId;
